import React, { useState } from 'react'
import { LineTabWrap } from './styles'

interface TabProps {
  tabList: any[]
  handleChange: (i: number) => void
}

const LineTab = ({tabList, handleChange}: TabProps) => {

  const [activeTab, setActiveTab] = useState(0)

  const handleClick = (i: number) => {
    setActiveTab(i)
    handleChange(i)
  }

  return (
    <LineTabWrap>
      <ul>
        {
          tabList.map((tab, index) => {
            return (
              <li key={index}>
                <button 
                  type='button'
                  onClick={() => handleClick(index)}
                  className={index === activeTab ? 'active' : ''}
                >{tab}</button>
              </li>
            )
          })
        }
      </ul>
    </LineTabWrap>
  )
}

export default LineTab  